import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styles from './UsageContainer.module.less';
import { UsageSelectors } from '../../../Redux/modules/usage/selectors';
import Tabs from '../../Tabs/Tabs';
import { UsageActions } from '../../../Redux/modules/usage/actions';
import Dashboard from '../components/Dashboard';

const DashboardContainer = (props) => {
  return (
    <div className={styles.container}>
      <Tabs
        tabs={[
          { title: gettext('Dashboard'), link: 'usage/dashboard/' },
          { title: gettext('Usage per user'), link: 'usage/per-user/' },
        ]}
      />
      <div className={styles.section}>
        <div className={styles.sectionDiv}>
          <Dashboard getUsageAnalytics={props.getUsageAnalytics} usageAnalyticsData={props.usageAnalyticsData} />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    usageAnalyticsData: UsageSelectors.usageAnalyticsDataSelector(state),
  };
};
const mapDispatchToProps = {
  getUsageAnalytics: UsageActions.fetchUsageAnalytics,
};
DashboardContainer.propTypes = {
  usageAnalyticsData: PropTypes.object,
  getUsageAnalytics: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardContainer);
